import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = React.createContext({
  tagline_en: "Ek Bhoomi • Ek Mitra • Ek Bharosa",
  tagline_hi: "एक भूमि • एक मित्र • एक भरोसा",
  management_phone: "+917014965172",
});

export function ConfigProvider({ children }) {
  const [cfg, setCfg] = useState({
    tagline_en: "Ek Bhoomi • Ek Mitra • Ek Bharosa",
    tagline_hi: "एक भूमि • एक मित्र • एक भरोसा",
    management_phone: "+917014965172",
  });
  useEffect(() => {
    api.get("/config").then(({ data }) => setCfg((c) => ({ ...c, ...data }))).catch(() => {});
  }, []);
  return <Ctx.Provider value={cfg}>{children}</Ctx.Provider>;
}

export const useConfig = () => React.useContext(Ctx);

export function formatINR(n) {
  const v = Number(n);
  if (isNaN(v)) return "-";
  if (v >= 1_00_00_000) return `₹${(v / 1_00_00_000).toFixed(2)} Cr`;
  if (v >= 1_00_000) return `₹${(v / 1_00_000).toFixed(2)} L`;
  if (v >= 1000) return `₹${(v / 1000).toFixed(1)}K`;
  return `₹${v.toLocaleString("en-IN")}`;
}
